module.exports = __webpack_public_path__ + "static/media/Latest_American_Express.9f5e825f.png";